<div class="table-empty-state" role="status" aria-live="polite">
    <img
        class="table-empty-state__logo"
        [src]="logoPath"
        alt="ComplyB4 logo"
    />
    <div class="table-empty-state__text">{{ message }}</div>
    <div class="table-empty-state__actions">
        <ng-content></ng-content>
    </div>
</div>
